import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
    selector: 'app-select-with-search',
    templateUrl: './select-with-search.component.html',
    styleUrls: ['./select-with-search.component.scss'],
    standalone: false
})
export class SelectWithSearchComponent implements OnInit {
  @Input() data: string;
  @Input() disabledFlag: boolean;
  @Input() label: string = "";
  @Input() placeholder: string = "";
  @Input() list: any[];
  @Output() focusOut: EventEmitter<string> = new EventEmitter<string>();

  tempValue: any;
  searchCtrl: string;

  constructor() {}

  ngOnInit() {
    this.searchCtrl = "";
  }

  onFocusOut() {
    this.focusOut.emit(this.data);
  }

  startEdit() {
    this.tempValue = this.data;
  }

  undo() {
    this.data = this.tempValue;
  }
}
